import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import {reset, setFirefly} from '../redux/userSlice';
import { reset as insuranceReset } from '../redux/insuranceSlice';
import { reset as stripeReset } from '../redux/stripeSlice';
import { reset as portalReset } from '../redux/portalSlice';
import Question from "../components/Question";
import ContinueButton from '../components/ContinueButton';
import { Box, Typography, Link } from "@mui/material";
import pictionLogo from "../assets/piction-logo.png";
import fireflyLogo from "../assets/firefly_logo.png";
import verticalLine from "../assets/vertical_line.png";
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

export default function FireflyLanding() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(reset());
        dispatch(insuranceReset());
        dispatch(stripeReset());
        dispatch(portalReset());
        dispatch(setFirefly(true));
    }, [dispatch]);

    return (
        <Box sx={{ minHeight: '100vh', overflow: 'hidden' }}>
            <Question
                noBack={true}
                main={true}
                returning={false}
                landing={true}
                heading={
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            margin: '16px 0'
                        }}>
                            <img
                                src={fireflyLogo}
                                alt="ZocDoc Logo"
                                style={{
                                    width: '140px',
                                    height: '70px',
                                    objectFit: 'contain'
                                }}
                            />
                            <img
                                src={verticalLine}
                                alt="Vertical Line"
                                style={{
                                    width: '40px',
                                    height: 'auto'
                                }}
                            />
                            <img
                                src={pictionLogo}
                                alt="Logo of Piction Health"
                                style={{
                                    width: "110px",
                                    height: '40px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </div>
                }
                title="Welcome to Piction Health!"
                subtitle={
                    <Typography variant="body2">
                        <br />
                        <strong>1. Provide Your Details</strong>
                        <br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;Fill out this intake form, which will provide us with some important information.
                        <br /><br/>
                        <strong>2. Schedule Your Video Visit</strong><br/>
                        &nbsp;&nbsp;&nbsp;&nbsp; We’ll text you a link for a 15-minute visit with a nurse practitioner who will review your concerns.
                        <br /><br/>
                        <strong>3. Get Your Personalized Care Plan</strong><br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;A board-certified dermatologist will create your treatment plan, typically within 48 hours.
                    </Typography>
                }
                input={
                    <Box sx={{ pt: '3vh', zIndex: 9999, }}>
                        <ContinueButton
                            onClick={() => setPageAndDeferNavigate(dispatch, '/concern', navigate)}
                            title="Let's go"
                            selected={true}
                        />
                    </Box>
                }
            />
            <Box sx={{
                position: 'absolute',
                bottom: 35,
                left: 0,
                right: 0,
                px: 4,
                textAlign: 'center'
            }}>
                <Typography
                    sx={{
                        fontSize: '0.75rem',
                        color: 'text.secondary',
                        '& a': {
                            color: '#666666',
                            textDecoration: 'underline',
                            '&:hover': {
                                color: '#333333'
                            }
                        }
                    }}
                >
                    By continuing, you agree that you're 18 or older and to our{' '}
                    <Link href="https://www.pictionhealth.com/informed-consent" target="_blank" rel="noopener">
                        Patient Consent
                    </Link>
                    ,{' '}
                    <Link href="https://www.pictionhealth.com/npp" target="_blank" rel="noopener">
                        Notice of Privacy Practices
                    </Link>
                    ,{' '}
                    <Link href="https://www.pictionhealth.com/privacy-policy" target="_blank" rel="noopener">
                        Privacy Policy
                    </Link>
                    , and{' '}
                    <Link href="https://www.pictionhealth.com/terms-of-use" target="_blank" rel="noopener">
                        Terms
                    </Link>
                    . By providing your phone number, you consent to receiving appointment reminders & information via text message. You can always opt out of reminders by replying "stop".
                </Typography>
            </Box>
        </Box>
    );
}
